import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../utils/api';
import './Login.css';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [resetOption, setResetOption] = useState('code'); // 'code' or 'link'

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setMessage('');

    try {
      const endpoint = resetOption === 'code' ? '/api/forgot-password' : '/api/request-password-reset';
      const response = await api.post(endpoint, { email });
      
      setMessage(response.data.message);
      
      if (resetOption === 'code') {
        // Redirect to verification page for code-based reset
        setTimeout(() => {
          navigate(`/reset-password-verify?email=${encodeURIComponent(email)}`);
        }, 2000);
      }
    } catch (error) {
      setError(error.response?.data?.error || 'Failed to send reset request');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        {/* Header with Cricket Logo */}
        <div className="login-header">
          <div className="cricket-logo">
            <svg width="60" height="60" viewBox="0 0 100 100" className="cricket-icon">
              <circle cx="50" cy="50" r="45" fill="#1e40af" stroke="#ffffff" strokeWidth="3"/>
              <rect x="35" y="20" width="6" height="60" fill="#ffffff" rx="3"/>
              <rect x="55" y="20" width="6" height="60" fill="#ffffff" rx="3"/>
              <rect x="45" y="20" width="6" height="60" fill="#ffffff" rx="3"/>
              <rect x="30" y="75" width="40" height="4" fill="#ffffff" rx="2"/>
              <circle cx="50" cy="35" r="8" fill="#ef4444"/>
            </svg>
          </div>
          <h1 className="academy-title">{process.env.REACT_APP_ACADEMY_NAME || 'MSKICA Cricket Academy'}</h1>
          <p className="academy-subtitle">Password Reset</p>
        </div>

        {/* Reset Form */}
        <div className="login-form-section">
          {error && (
            <div className="error-alert">
              <span className="error-icon">⚠️</span>
              <span>{error}</span>
            </div>
          )}

          {message && (
            <div className="success-alert">
              <span className="success-icon">✅</span>
              <span>{message}</span>
            </div>
          )}

          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <label htmlFor="email" className="form-label">
                <span className="label-icon">📧</span>
                Email Address
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="form-input"
                placeholder="Enter your registered email"
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">
                <span className="label-icon">🔄</span>
                Reset Method
              </label>
              <div className="radio-group">
                <label className="radio-option">
                  <input
                    type="radio"
                    name="resetOption"
                    value="code"
                    checked={resetOption === 'code'}
                    onChange={(e) => setResetOption(e.target.value)}
                  />
                  <span className="radio-label">
                    <strong>Verification Code</strong>
                    <small>Receive a 6-digit code via email</small>
                  </span>
                </label>
                
                <label className="radio-option">
                  <input
                    type="radio"
                    name="resetOption"
                    value="link"
                    checked={resetOption === 'link'}
                    onChange={(e) => setResetOption(e.target.value)}
                  />
                  <span className="radio-label">
                    <strong>Reset Link</strong>
                    <small>Receive a secure link via email</small>
                  </span>
                </label>
              </div>
            </div>

            <button 
              type="submit" 
              className="login-btn"
              disabled={loading}
            >
              {loading ? (
                <>
                  <div className="spinner"></div>
                  Sending...
                </>
              ) : (
                <>
                  <span>{resetOption === 'code' ? 'Send Code' : 'Send Link'}</span>
                  <span className="btn-icon">📧</span>
                </>
              )}
            </button>
          </form>

          {/* Footer Links */}
          <div className="login-footer">
            <Link to="/login" className="footer-link">
              Remember your password? <strong>Sign In</strong>
            </Link>
            
            <Link to="/register" className="footer-link">
              Don't have an account? <strong>Create one</strong>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
